import React, { useState, useEffect } from 'react';
import styled from '@emotion/styled';
import { Navigate, useNavigate } from 'react-router-dom';
import useSWR from 'swr';
import he from 'he';

import { Body } from '@components/templates';
import { Filters, Worklist, Pagination } from '@components/organisms';
import { useRecoilState } from 'recoil';
import { ADMIN_ACCESS_TOKEN_KEY } from '../../../App';
import { DEFAULT_CURRENT_PAGE } from '@components/organisms/Table/Pagination';
import { userPageCurrentPageState } from '@pages/Permissions/User';
const StyledFlexColumnsWrapper = styled.main`
  width: 100%;
  table {
    tr[data-highlight='deactivated' i] {
      td {
        background-color: #fafafa;
        color: #999999;
      }
    }

    td > u {
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      :hover {
        color: #7fe200;
      }
      b {
        color: #7fe200;
      }
      & > div {
        margin-left: 6px;
        background-color: #ffffff;
      }
      &:hover > div {
        border-color: #7fe200;
        background-color: #effdda;
        :before,
        :after {
          border-color: #7fe200;
        }
      }
      &:active > div {
        border-color: #7fe200;
        background-color: #7fe200;
        :before,
        :after {
          border-color: #ffffff;
        }
      }
    }
  }
`;

const StyledSearchBarWrapper = styled.section`
  display: flex;
  justify-content: space-between;
  align-items: center;
  & > div:nth-of-type(1) {
    margin-left: 0;
  }
`;

const CompanyLog = () => {
  const navigate = useNavigate();
  const [accessToken, setAccessToken] = useState('');
  const [valueState, setValueState] = useState({
    searchKey: 'ID',
    searchKeyword: '',
  });
  const [pageConditionsValue, setPageConditionsValue] = useRecoilState(userPageCurrentPageState);

  useEffect(() => {
    const newToken = localStorage.getItem(ADMIN_ACCESS_TOKEN_KEY);
    if (newToken) {
      setAccessToken(newToken);
    }
  }, []);

  useEffect(() => {
    if (valueState)
      setPageConditionsValue((prev) => ({
        ...prev,
        currentPage: DEFAULT_CURRENT_PAGE,
      }));
  }, [valueState]);

  const url = `api/transfer/logs/company?countPerPage=${pageConditionsValue.countPerPage}&currentPage=${
    pageConditionsValue.currentPage
  }&searchType=${valueState.searchKey || ''}&searchValue=${valueState.searchKeyword || ''}`;

  const { data } = useSWR(!!accessToken.length ? [{ url, accessToken }] : null);

  let companyLogs: any[] = [];
  if (data) {
    if (data.code === 'UNAUTHORIZED') return <Navigate to={'/'} replace={true} />;

    if (data.code === '200') {
      const { countPerPage, currentPage, totalCount } = data.result.condition;
      const startNo = totalCount - (currentPage - 1) * countPerPage;
      data.result.results.map((item: any, index: number) =>
        companyLogs.push({
          no: startNo - index,
          id: item.companyId,
          company: he.decode(item.companyName),
          old: he.decode(item.before),
          new: he.decode(item.after),
          update_date: item.createdDatetime,
        }),
      );
    }
  }

  const moveToDetailItemPage = (item: any) => {
    navigate(`/transfer/sending/${item.id}`);
  };
  console.log(data, 'data');

  return (
    <>
      <label>Company Log</label>
      <Body data-page-type={'table-only'}>
        <StyledFlexColumnsWrapper>
          <StyledSearchBarWrapper>
            <Filters
              searchConditions={valueState}
              setSearchConditions={setValueState}
              conditionType={{
                searchType: [
                  {
                    label: 'ID',
                    value: 'ID',
                  },
                  {
                    label: 'Company',
                    value: 'COMPANY',
                  },
                ],
              }}
              hasRangeType={false}
            />
          </StyledSearchBarWrapper>
          <Worklist
            headers={[
              { label: 'No', data_label: 'no' },
              { label: 'ID', data_label: 'id' },
              { label: 'Company', data_label: 'company' },
              { label: 'Old', data_label: 'old' },
              { label: 'New', data_label: 'new' },
              { label: 'Update Date', data_label: 'update_date' },
            ]}
            data={{ dataArray: companyLogs }}
            customColumn={{
              company: (row) => (
                <u
                  className={row.account === 'deleted' ? 'deleted' : ''}
                  onClick={() => {
                    if (row.account !== 'deleted') moveToDetailItemPage(row);
                  }}
                >
                  {row.company}
                </u>
              ),
            }}
          />
          {data && data.result && data.result?.condition.totalCount > 0 && (
            <Pagination conditions={data.result.condition} setConditions={setPageConditionsValue} />
          )}
        </StyledFlexColumnsWrapper>
      </Body>
    </>
  );
};

export default CompanyLog;
